import { Wordmark } from '../../brand/Wordmark';
import { shared } from '../content/shared';
import s from '../site.module.css';

/** The public pages' footer. Not the tenant portal's "Powered by" line: these pages are Pairing's own. */
export function SiteFooter() {
  const f = shared.footer;
  return (
    <footer className={s.footer}>
      <div className={s.footerInner}>
        <a href={f.lockup.href} className={s.homeLink} aria-label={f.lockup.label}>
          <Wordmark size={22} tone="light" />
        </a>
        <nav aria-label={f.navLabel}>
          <ul className={s.footerLinks}>
            {f.links.map((l) => (
              <li key={l.href}>
                <a href={l.href}>{l.label}</a>
              </li>
            ))}
          </ul>
        </nav>
        <p className={s.copyright}>{f.copyright}</p>
      </div>
    </footer>
  );
}
